import { Alert } from "common-components";
// 1. React Core Hooks
import { useState } from "react"; // React hooks for lifecycle and state
// 2. WebSocket Libraries
// STOMP client for messaging over WebSockets
// WebSocket fallback library for better browser support
// 3. Utilities / Services
import GetProxy from "./GetProxy"; // API proxy or HTTP service utility
// decrypt import removed — using decodedUsername from Redux
// 4. Redux
import { useSelector } from "react-redux"; // Redux hook to access state
// 5. Custom Components
// Custom alert component for UI feedback

const proxy = GetProxy();

const WebSocketHandler = ({ onLogout }) => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("warning");

  const { decodedUsername } = useSelector((state) => state.common.loggedUser);
  const encoded = decodedUsername; // This is the current logged-in user ID

  // useEffect(() => {
  //   if (!encoded) return; // If no user, skip subscription

  //   const stompClient = new Client({
  //     webSocketFactory: () => new SockJS(`${proxy}/cmdb/websocket`),
  //     reconnectDelay: 5000,
  //     onConnect: () => {
  //       console.log(`Subscribed to /topic/user/${encoded}`);
  //       stompClient.subscribe(`/topic/user/${encoded}`, (message) => {
  //         const payload = JSON.parse(message.body);
  //         const { type, message: msg } = payload;

  //         if (type === 'ROLE_UPDATED' || type === 'USER_DISABLED') {
  //           setAlertMessage(msg);
  //           setAlertType(type === 'ROLE_UPDATED' ? 'warning' : 'danger');
  //           setShowAlert(true);

  //           // Delay logout
  //           setTimeout(() => {
  //             setShowAlert(false);
  //             onLogout(); // Logs out the user
  //           }, 5000);
  //         }
  //       });
  //     },
  //     onStompError: (frame) => {
  //       console.error('STOMP Error:', frame.headers['message']);
  //     },
  //   });

  //   stompClient.activate();

  //   return () => {
  //     stompClient.deactivate();
  //   };
  // }, [encoded, onLogout]); // ✅ Add encoded here to re-run when user changes

  return (
    <>
      {showAlert && (
        <Alert alert={showAlert} type={alertType} message={alertMessage} />
      )}
    </>
  );
};

export default WebSocketHandler;
